
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { emptyToLine } from "@common/src/utils/common";
import t from "@common/src/i18n/t";
import { addCurrencyUnit } from "@common/src/utils/tools";

const marketing = namespace("marketing");
@Component({})
export default class ValueCardView extends Vue {
  @marketing.Action queryCardTemplateDetail;
  emptyToLine = emptyToLine;
  addCurrencyUnit = addCurrencyUnit;
  valueCardForm = {
    cardTemplateName: "",
    cardAmount: "",
    giftAmount: "",
    enableStatus: 1,
    checked: true,
    usefulLife: t("marketing.permanent"),
    validPeriod: -1,
    cardDesc: "",
    cardType: 2,
    cardTemplateCode: "",
    carryingAmount: "",
    usedStatus: undefined
  };
  //计算属性
  get computeCountMoney() {
    return (Number(this.valueCardForm.cardAmount) + Number(this.valueCardForm.giftAmount)).i18nToFixed();
  }
  get isAdd() {
    return this.$route.name === "ValueCardAdd";
  }
  get breadData() {
    return [
      { name: t("marketing.card-template"), path: "/marketing/card-template" },
      {
        name: t("v210831.stored-value-card")
      }
    ];
  }
  created() {
    this.queryCardTemplateDetail({ cardTemplateCode: this.$route.params.id }).then(res => {
      this.valueCardForm.cardAmount = res.data.cardAmount;
      this.valueCardForm.cardDesc = res.data.cardDesc;
      this.valueCardForm.cardTemplateCode = res.data.cardTemplateCode;
      this.valueCardForm.cardTemplateName = res.data.cardTemplateName;
      this.valueCardForm.carryingAmount = res.data.carryingAmount;
      this.valueCardForm.enableStatus = res.data.enableStatus;
      this.valueCardForm.giftAmount = res.data.giftAmount;
      this.valueCardForm.usedStatus = res.data.usedStatus;
    });
  }

  goToEdit() {
    this.$router.push(`/marketing/value-card-edit/${this.$route.params.id}`);
  }
}
